import React from "react"
import styled, { css } from "styled-components"
import { Link, CardStyle, Paragraph } from "buoy-core"
import Title, { TitleContainer, Bold, DetailColumn, Icon } from "./Title"
import { ProfileInformation } from "./ProfileInformation"
import { SubsectionAction, SubsectionDisplay } from "./Subsection"

export const SwitchCard = styled.div`
  ${CardStyle};
  border-top: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 16px;
  transition: transform 0.25s ease;

  :hover {
    ${props =>
      !props.selected
        ? css`
            transform: scale(1.05);
            box-shadow: 0 0 18px 0 rgba(0, 0, 0, 0.1);
            div {
              opacity: 1;
            }
          `
        : ""};
  }
`

const ProfileSelect = ({
  name,
  selected,
  isself,
  onClick,
  dashboard,
  collapse,
  selectedProfile,
  percentsComplete,
}) => {
  if (!selectedProfile) {
    const percentsComplete = {
      basicInfo: 0,
      generalHealth: 0,
      medicalHistory: 0,
    }
    return (
      <SwitchCard selected={true}>
        <TitleContainer onClick={onClick} selected={true}>
          <Icon>+</Icon>
          <DetailColumn>
            <Bold>+ Add profile name</Bold>
            <Paragraph color="neutral" margin="0">
              Primary profile
            </Paragraph>
          </DetailColumn>
        </TitleContainer>
        {!collapse && (
          <React.Fragment>
            <ProfileInformation percentsComplete={percentsComplete} />
            <SubsectionAction
              dashboard={dashboard}
              title="Visit History"
              link="/profile/visits/"
            />
            <SubsectionAction
              dashboard={dashboard}
              title="Account Settings"
              link="/profile/settings/"
            />
          </React.Fragment>
        )}
      </SwitchCard>
    )
  }

  return (
    <SwitchCard selected={selected}>
      <Title
        name={name}
        selected={selected}
        isself={isself}
        onClick={onClick}
        dashboard={dashboard}
      />
      {selected && (
        <React.Fragment>
          {dashboard && !collapse ? (
            <React.Fragment>
              <ProfileInformation
                showReproductiveHistory={selectedProfile.sex === "f"}
                percentsComplete={percentsComplete}
              />
              {Object.keys(percentsComplete).some(
                key => percentsComplete[key] === 100
              ) && (
                <SubsectionAction
                  title="Profile Information"
                  link="/profile/"
                />
              )}
            </React.Fragment>
          ) : (
            !collapse && (
              <SubsectionAction
                title="Profile Information"
                link="/profile/"
              />
            )
          )}
          {!collapse && (
            <React.Fragment>
              <SubsectionAction
                dashboard={dashboard}
                title="Visit History"
                link="/profile/visits/"
              />
              {isself && (
                <SubsectionAction
                dashboard={dashboard}
                title="Account Settings"
                link="/profile/settings/"
                />
              )}
            </React.Fragment>
          )}
          {!dashboard && (
            <SubsectionDisplay>
              <Paragraph margin="0" color="black" underline={false}>
                Questions?{" "}
                <Link href="https://help.buoyhealth.com/">
                  Check out our FAQ
                </Link>
              </Paragraph>
            </SubsectionDisplay>
          )}
        </React.Fragment>
      )}
    </SwitchCard>
  )
}

export { ProfileSelect as default }



// WEBPACK FOOTER //
// ./assets/common/components/ProfileSwitcher/components/ProfileSelect.js